/**
 * Canonical click-ID parameter names captured by the SDK and flattened by the
 * server. Keys are LOWERCASE — case-insensitive matching at capture time
 * normalizes URL params to these canonical forms before persistence.
 *
 * Single source of truth: both SDK and server import this list.
 *
 * Convention: keys with a leading underscore (e.g. `_ef_transaction_id`) are
 * preserved verbatim — server flatten knows to map them (strips the underscore,
 * prefixes with `click_`).
 *
 * Adding a new platform:
 *   1. Add the lowercase param name here.
 *   2. Add the TTL (days) to CLICK_ID_TTL_DAYS in packages/sdk-js/src/utils.ts.
 *   3. Add the BQ column to Terraform.
 */
export const CANONICAL_CLICK_IDS = [
    // Google
    'gclid',
    'gbraid',
    'wbraid',
    'gad_source',
    'gad_campaignid',
    'gclsrc',
    'dclid',
    'srsltid',
    // Meta
    'fbclid',
    // TikTok
    'ttclid',
    // Microsoft / Bing
    'msclkid',
    // LinkedIn
    'li_fat_id',
    // X (Twitter)
    'twclid',
    // Pinterest
    'epik',
    // Snapchat — canonical lowercase; ScCid variants matched via case-insensitive URL lookup
    'sc_cid',
    // Reddit
    'rdt_cid',
    // Taboola
    'tblci',
    // Outbrain
    'obclid',
    // Amazon Attribution
    'awclid',
    // Nextdoor
    'ndclid',
    // Quora
    'qclid',
    // Yandex
    'yclid',
    'ysclid',
    'yadclid',
    // HubSpot HSA family
    'hsa_cam',
    'hsa_grp',
    'hsa_ad',
    'hsa_mt',
    'hsa_src',
    'hsa_acc',
    'hsa_net',
    'hsa_kw',
    'hsa_tgt',
    'hsa_ver',
    // Everflow
    '_ef_transaction_id',
    // Impact.com
    'irclickid',
    'ir_campaignid',
    'ir_partnerid',
    'ir_mediatype',
    'ir_adid',
    'sharedid',
    // ShareASale
    'sscid',
    'sastid',
    'afftrack',
    // CJ Affiliate
    'cjevent',
    'cjdata',
    // Awin
    'awc',
    'clickref',
    // Rakuten
    'ransiteid',
    'ranmid',
    'raneaid',
    // Generic affiliate sub-IDs (ClickBank, others)
    'tid',
    'aff_sub1',
    'aff_sub2',
    'aff_sub3',
    'aff_sub4',
    'aff_sub5',
    // Rewardful
    'via',
    // FirstPromoter
    'fpr',
    'fp_sid',
    // Refersion
    'rfsn',
    // Tapfiliate
    'tap_vid',
    // PartnerStack
    'ps_xid',
    // AvantLink
    'avad',
    // Friendbuy
    'fbuy_ref_code',
    // Referral Rock
    'rr_ref',
    'rr_code',
    // Post Affiliate Pro
    'a_aid',
    // LeadDyno
    'afmc',
    // Email campaigns
    'mc_cid',
    'mc_eid',
    '_kx',
];
export const CANONICAL_CLICK_ID_SET = new Set(CANONICAL_CLICK_IDS);
//# sourceMappingURL=click-ids.js.map